/**
 * API Configuration
 * Update this with your PHP backend URL
 */

// API Base URL - defaults to production, falls back to localhost for development
const getApiBaseUrl = () => {
  // Use environment variable if set
  if (import.meta.env.VITE_API_BASE_URL) {
    const envUrl = import.meta.env.VITE_API_BASE_URL.replace(/\/+$/, ''); // Remove trailing slashes
    
    // If in dev mode and pointing to production, use Vite proxy to bypass CORS
    if (import.meta.env.DEV && (envUrl.includes('gugandentalcare.com') || envUrl.includes('https://'))) {
      console.log('Development mode: Using Vite proxy to bypass CORS');
      return '/api-proxy'; // Use Vite proxy
    }
    
    return envUrl;
  }
  
  // Development - use local backend
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:8000/backend/api';
  }
  
  // Production: Based on your working URL, use /api/api (double api)
  // If check.php works at /api/api/check.php, use that path
  return `${window.location.protocol}//${window.location.hostname}/api/api`;
};

export const API_BASE_URL = getApiBaseUrl();

// Always log API URL for debugging (even in production)
console.log('API Base URL:', API_BASE_URL);

export const apiRequest = async (endpoint, options = {}) => {
  const token = localStorage.getItem('session_token');
  
  const defaultHeaders = {
    'Content-Type': 'application/json',
  };
  
  if (token) {
    defaultHeaders['Authorization'] = `Bearer ${token}`;
  } else {
    console.warn('No session token found in localStorage for request to:', endpoint);
  }
  
  const config = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  };
  
  // Clean endpoint - remove leading slashes and 'api/' prefix if present
  const cleanEndpoint = endpoint.replace(/^\/+/, '').replace(/^api\//, '');
  const url = `${API_BASE_URL}/${cleanEndpoint}`;
  
  // Log the actual URL being called for debugging
  console.log('API Request URL:', url);
  
  try {
    const response = await fetch(url, config);
    
    // Get response text first to check if it's JSON
    const text = await response.text();
    
    // Try to parse as JSON
    let data;
    try {
      data = JSON.parse(text);
    } catch (parseError) {
      // If it's not JSON, it's likely an HTML error page
      console.error('API returned non-JSON response. URL:', url);
      console.error('Response status:', response.status);
      console.error('Response headers:', Object.fromEntries(response.headers.entries()));
      console.error('Response text (first 1000 chars):', text.substring(0, 1000));
      
      // Try alternative paths if main path fails
      if (!url.includes('/api/api/')) {
        console.warn('Trying alternative path with /api/api/');
        const altUrl = url.replace('/api/', '/api/api/');
        console.log('Trying alternative URL:', altUrl);
        // Don't auto-retry, just log for now
      }
      
      throw new Error(`Server error: Received HTML instead of JSON. Check if API endpoint exists at ${url}. Response status: ${response.status}`);
    }
    
    if (!response.ok) {
      // Use message if available, otherwise error, otherwise generic message
      const errorMessage = data.message || data.error || `Request failed (${response.status})`;
      throw new Error(errorMessage);
    }
    
    return data;
  } catch (error) {
    console.error('API Request Error:', error);
    throw error;
  }
};

